import Vue from 'vue'
import initialState from './defaultState'

export default {
    resetStateMutation(state) {
        const defaultState = initialState();

        Object.keys(state).forEach(item => {
            Vue.set(state, item, defaultState[item]);
        })
    },

    modifyOccuHeaAdminPartnerInputReadOnly(state, contactId) {
        let tempArray = state.occupationHealthHeaderFields;
        let index = tempArray.findIndex(element => {
            return element.name === "partnerId"
        });

        switch (contactId) {
            case 821:
                tempArray[index].formReadOnly= false;
                break;
            default:
                tempArray[index].formReadOnly= true;
                break;
        }
    }
}
